import { render, staticRenderFns } from "./HR.vue?vue&type=template&id=28397fa5"
import script from "./HR.vue?vue&type=script&lang=js"
export * from "./HR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports